import React from "react";

const HomeServices = () => {
  const servicesData = [
    {
      id: 1,
      title: "Property Buying",
      description:
        "We assist you in finding and buying the perfect residential or commercial property with expert guidance.",
    },
    {
      id: 2,
      title: "Property Selling",
      description:
        "Get the best value for your property through professional pricing, marketing, and buyer outreach.",
    },
    {
      id: 3,
      title: "Property Leasing",
      description:
        "End-to-end leasing services for homes and commercial spaces with verified tenants.",
    },
    {
      id: 4,
      title: "Real Estate Consulting",
      description:
        "Smart investment advice based on current market trends and future growth opportunities.",
    },
      {
      id: 5,
      title: "Portfolio Management",
      description:
        "Comprehensive management of your real estate assets to maximize returns, minimize risk, and ensure long-term growth.",
    },
    
   
  ];

  return (
   
    <div className="backdiv1">
      <h2 className="sapt-head text-center">OUR SERVICES</h2>

      <div className="home-services-grid">
        {servicesData.map((service) => (
          <div className="service-home-card" key={service.id}>
            <div>
            <div className="service-icon">{service.icon}</div>
            <h3 className="home-ser-head">{service.title}</h3>
            <p className="home-ser-content">{service.description}</p>
            </div>
          </div>
        ))}
      </div>
      </div>
  
  );
};

export default HomeServices;
